import { Flex, Paper, Text, Title } from "@mantine/core";

export default function PricingFAQSection() {
  return (
    <Flex py="xl" justify="center" bg="#EFF6FF">
      <Flex direction="column" align="center" style={{ maxWidth: 720, width: "100%" }} px="md">
        <Title order={2} mb="xs">
          Pricing FAQs
        </Title>
        <Text mb="xl">Common questions about our pricing model</Text>

        {[
          "Do I need to pay to browse companies?",
          "When exactly do I need to pay?",
          "What does the collaboration workspace include?",
          "Can I cancel or extend the workspace?",
          "What if the other company doesn't match with me?",
          "Do you offer volume discounts?",
        ].map((q) => (
          <Paper key={q} p="md" radius="md" mb="xs" style={{ border: "1px solid #DEE2E6", width: "100%" }}>
            <Flex justify="space-between" align="center">
              <Text>{q}</Text>
              <Text size="lg">›</Text>
            </Flex>
          </Paper>
        ))}
      </Flex>
    </Flex>
  );
}
